<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
  	<div class="table-box layui-body" style="left:0;">
      <div class="xblock layui-form">
        <div class="layui-input-inline xblock-row">
    				<input type="text" class="layui-input" id="order_date" placeholder=" - " autocomplete="off" />
        </div>
        <div class="x-right xblock-row">
          <span class="x-right" v-text="'共有数据：'+count+ '条'"></span>
          <span class="x-right" v-text="'已募集：'+data_total.ready_money+ '元　|　'"></span>
          <span class="x-right" v-text="'总需求：'+data_total.total_money+ '元　|　'"></span>
        </div>
        <div class="clear-both"></div>
      </div>

  		<table class="layui-table">
  			<thead>
  				<tr>
            <th>标题</th>
  					<th>需求金额</th>
  					<th>剩余金额</th>
  					<th>利息</th>
  					<th>预计支出</th>
  					<th>利息</th>
  					<th>参与人数</th>
  					<th>发起时间</th>
  					<th>入账时间</th>
  					<th>操作</th>
  				</tr>
  			</thead>
  			<tbody v-for="(item,index) in list" v-bind:key="index">
  				<tr class="order_box">
  					<td v-text="item.name"></td>
  					<td v-text="item.total_money"></td>
  					<td v-text="item.need_money"></td>
  					<td v-text="item.income"></td>
  					<td v-text="item.total"></td>
  					<td v-text="item.interest_rate+'%'"></td>
  					<td v-text="item.user_info_list.length"></td>
            <td v-text="item.created_at"></td>
            <td v-text="item.end_date"></td>
            <td class="btn-arr">
              <button class="layui-btn" @click="ViewProducts(index,item)">资方列表</button>
              <button class="layui-btn layui-btn-normal" @click="PageGo(item.batch_id,'FinOrder')">订单列表</button>
            </td>
  				</tr>
          <tr class="product_box" v-viewer v-if="item.show">
            <td colspan="14" class="product_box_tr" style="border:0;background-color: #FAFAFA;">
              <div class="product_box">
                <div class="table-header">
                  <table class="layui-table">
                    <tbody class="images">
                      <tr>
                        <td colspan="14" class="product_box_tr" style="border:0;padding:0 !important;margin-top:0;">
                          <div>
                            <table class="layui-table" style="margin: 0;">
                              <thead>
                                <tr class="trth">
                                  <th>头像</th>
                                  <th>名称</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(val,ix) in item.user_info_list">
                                  <td style="width:60px;">
                                    <div class="table_img">
                                      <img v-if="val.is_open == 1 && val.head_url" :src="val.head_url">
                                      <img v-else src="../../../../static/images/mystery.png">
                                    </div>
                                  </td>
                                  <td style="width:150px;word-break:break-all;" v-text="val.name"></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </td>
          </tr>
  			</tbody>
  		</table>

      <!-- transition -->
      <K-Transition v-if="list.length < 1"></K-Transition>

  	</div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
var self,form,layer,laypage,laydate;
import axios from 'axios'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Transition from '@/components/common/Transition.vue'
export default {
  name: 'MemberRechargeLog',
  components: {
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-Transition': Transition,
  },
  data () {
    return {
      loading:false,
      Toast: {
        state: false,
        type: 0,
        txt: null
      },
      page: 1,
      count: 0,
      money:0,
      page_num:20,
      current_status: 0,
      status_id:0,
      list: [],
      data_total:{},
      status: [{
        id:1,
        name:"未完成"
      },{
        id:2,
        name:"已完成"
      }]
    }
  },
  mounted () {
    self = this;

    layui.use(['form', 'layer' , 'laydate', 'laypage'], function() {

      form = layui.form;
    	layer = layui.layer;
    	laypage = layui.laypage;
    	laydate = layui.laydate;

      //时间控件
      laydate.render({
        elem: '#order_date',
        range: true
      });

    	form.on('select(status_selection)', function(data) {
    		var val = $("select[name=status]").val() - 1;
    		self.current_status = val;
    		var status;
    		if (val != -1) {
    			status = self.status[self.current_status].id;
    		} else {
    			status = 0;
    		}
    		self.status_id = status; //获取当前站点
    		self.get_recharge_record(true)
    	});
      form.render('select');

      self.get_recharge_record()
    });

  },
  methods:{
    ToastFun(type, txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast() {
      self.Toast.state = false;
    },
    ViewProducts (ix,item) {
      if(item.user_info_list.length <= 0){
        self.ToastFun(1, "暂无投资人！"); //弹窗提醒
        return;
      }
      if(item.show){
        self.list[ix].show = false;
      }else{
        self.list[ix].show = true;
      }
      self.$forceUpdate();
    },
    PageGo (id,url) {
      localStorage.setItem("ExShopee_batch_id",id);
      localStorage.setItem("ExShopee_HistoryURL", "FinOrder");
      self.GoToPage('/'+url); // 路由跳转
    },
    get_recharge_record () {
      //获取的结束时间自动加一天
      var t = $("#order_date").val();
      var start_time, end_time;
    	if (t) {
    		self.getDate(t, function(s, e) {
    			start_time = s;
    			end_time = e;
    		})
    	}

    	self.loading = true;
      let param = new URLSearchParams()
      param.append('num', self.page_num)
      if(start_time){
        param.append('start_time', start_time)
      }
      if(end_time){
        param.append('end_time', end_time)
      }

      param.append('status', self.status_id)
      axios({
        method: 'post',
        url: self.GetServerUrl()+"/financing_list/?page=" + self.page,
        data:param,
        headers: {'token': localStorage.getItem("ExShopee_token")}
      }).then(function (response) {

        //返回数据处理
        self.ReturnFuntion(self,response,function(datas){
          self.count = datas.page.count;
          var list = datas.list;
          for(let i in list){
            list[i].show = false;
            list[i].total = (list[i].total_money * (1+list[i].interest_rate*0.01)).toFixed(2);
            list[i].income = (list[i].total_money * (list[i].interest_rate*0.01)).toFixed(2);
            var s2 = list[i].end_date,s1;
            s1 = new Date();//当前日期：2017-04-24
            s2 = new Date(s2.replace(/-/g, "/"));
            var days = s2.getTime() - s1.getTime();
            var time = parseInt(days / (1000 * 60 * 60 * 24));
            list[i].date = time+1;
          }
          self.list = list;
          self.data_total = datas.statics_list;
          self.money = datas.money;
          self.ShowPage(self,laypage,"get_recharge_record"); //分页
          $('.pagebox').show();
        },false);

      }).catch(function (error) {
        self.loading = false;
        self.ToastFun(2, error); //弹窗提醒
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
td{
  padding: 18px 15px;
}
.country_select {
    width: 150px;
}
  .table_img{
    width: 60px !important;
    height: 60px !important;
  }
  .total-data{
	padding:12px 10px;
	line-height: 18px;
}
.total-data-row{
	color:#444;
	padding-right: 30px;
	margin-right: 30px;
	border-right: 1px solid #CCC;
	font-family: Microsoft YaHei, arial;
	font-family: arial;
	font-size: 15px;
}
.total-data-row:last-child{
	border-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/finance/Raise.vue